import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { Country, Currency, MerchantCategorie,  PartnerDto,RoleDto, UserDto } from '../api/models';
import { CountryCtlService, CurrencyCtlService, PartnerCtlService, UserControllerService } from '../api/services';
import { SessionService } from '../common/session.service';
import * as bootstrap from 'bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-partner',
    imports: [
      CommonModule,
    ReactiveFormsModule,
    NgxPaginationModule
],
    templateUrl: './partner.component.html',
    styleUrl: './partner.component.css'
})
export class PartnerComponent implements OnInit{


   pageConfig= {
    itemsPerPage: 10,
    currentPage: 0,
    totalItems: 0

   };
    addPartnerForm:FormGroup;
    updatePartnerForm:FormGroup;
    partnerTypes =environment.partnerTypes;
    countries?:Array<Country>;
    currencies?:Array<Currency>;
    mccs?:Array<MerchantCategorie>;
    roles?:Array<RoleDto>;
    listPartners:Array<PartnerDto>=[];
    message?:string;
    isAddPartner:boolean=false;
    isUpdatePartner=false;
    currentPartner?:PartnerDto;
    connectedUser?:UserDto;
    parents:Array<PartnerDto>=[];

  constructor(private formbuilder:FormBuilder,
    private partnerService:PartnerCtlService,
    private session:SessionService,
    private currencyService:CurrencyCtlService,
    private countryService:CountryCtlService,
    private userService:UserControllerService
  ){

    this.addPartnerForm= this.formbuilder.group({
      partnerName :['', [Validators.required]],
      partnerCode :[''],
      partnerAddress :['', [Validators.required]],
      partnerPhone: ['',[Validators.required,Validators.minLength(12)]],
      partnerEmail:['',Validators.email],
      parentId: ['',[Validators.required]],
      partnerType:['',Validators.required],
      partnerCurrency:['',Validators.required],
      partnerCountry:['SN',Validators.required],
      receiptionRef:['',[Validators.required,Validators.minLength(24)]],
      partnerMcc: ['']
    });
    this.updatePartnerForm= this.formbuilder.group({
      partnerId: ['',Validators.required],
      partnerName :['', [Validators.required]],
      partnerAddress :['', [Validators.required]],
      parentId: ['',[Validators.required]],
      partnerPhone: ['',[Validators.required,Validators.minLength(12)]],
      partnerEmail:['',Validators.email],
      partnerType:['',Validators.required],
      partnerCurrency:['',Validators.required],
      partnerCountry:['',Validators.required],
      partnerMcc: [''],
    });

  }
  ngOnInit(): void {
     this.connectedUser = this.session.getSessionInfo();
    this.getCurrencies();
    this.getCountries();
    this.getMcc();
    this.getPartners(this.pageConfig.itemsPerPage,0);
    this.loadParents();
  }

  onAddPartner():void{
    console.log(this.addPartnerForm.valid);
    if(this.addPartnerForm.valid){

      let formVal =this.addPartnerForm.value;
      
      let pCountry:Country={
        isoCode2: formVal.partnerCountry
      };
      let pCurrency:Currency ={
        code: formVal.partnerCurrency
      };
      let receiptRef=formVal.receiptionRef;
      if(formVal.partnerType!='MERCHANT'){
        receiptRef ='';
      }
      
      let partnerDto:PartnerDto ={
        name: formVal.partnerName,
        phone: formVal.partnerPhone,
        email: formVal.partnerEmail,
        type: formVal.partnerType,
        address: formVal.partnerAddress,
        code: formVal.partnerCode,
        country:pCountry,
        parent: {id: formVal.parentId} as PartnerDto,
        currency:pCurrency,
        mcc: formVal.partnerMcc,
        receptionMean:receiptRef
      };
      this.partnerService.createPartner1(
       partnerDto
      ).subscribe({
        next:()=>{
          
          this.addPartnerForm.reset();
          const elt =document.getElementById('modAddPartner');
           const modAdd = new bootstrap.Modal(elt!!);
           modAdd.show();

        },
        error:(err)=> {
           this.session.handleError(err);
        },
      });

    }else {
      console.log(this.addPartnerForm.errors);
    }
  }
  displayMessage(){
    const elt =document.getElementById('toastMessage');
    const toast = new bootstrap.Toast(elt!!);

    toast.show();
  }

  getCurrencies(){
    this.currencyService.getCurrencies().subscribe({
      next:(resp)=>{
        this.currencies=resp;
      },
      error:(err)=>{
        this.session.handleError(err);
      }
      
    });

  }
  getCountries(){
    this.countryService.getCountries().subscribe({
      next:(resp)=>{
        this.countries=resp;
      },
      error:(err)=>{
        this.session.handleError(err);
      }
      
    });

  }
  getMcc(){
    this.partnerService.getAllMcc().subscribe({
      next:(resp)=>{
        this.mccs=resp;
      },
      error:(err)=>{
        this.session.handleError(err);
      }
      
    });

  }
  getRoles(){
    let role = this.session.getSessionInfo().role;
    let connectedRole = role?.code?role.code:'';
    this.userService.getRoles(
     connectedRole,
    this.addPartnerForm.value.partnerType
  ).subscribe({
      next:(resp)=>{
        this.roles =resp;
        if(this.addPartnerForm.value.partnerType!='MERCHANT'){
          this.addPartnerForm.controls['receiptionRef'].setValue('SN0000000000000000000000');
        }
        console.log(this.roles.at(0)?.code);

      },
      error:(err)=>{}
    });
  }
  onNextPage(event:number){
    console.log(event);
    this.getPartners(this.pageConfig.itemsPerPage,event-1);

  }
  loadParents(){
    this.partnerService.getParents().subscribe({
      next:(resp:PartnerDto[])=>{
        this.parents=resp;
      },
      error:(err:HttpErrorResponse)=>{
        this.session.handleError(err);
      }
      
    });
  }
  getPartners(pageSize:number=2,pageNumber:number=0){
    let partner = this.session.getSessionInfo().partner?.id!!;
    let typeP:any="MERCHANT";
    this.partnerService.getChildren1(
     partner,
     typeP,
     pageSize,
      pageNumber
    ).subscribe({
      next:(resp)=>{
        this.pageConfig.currentPage = resp.page?.number!!+1;
        this.pageConfig.totalItems = resp.page?.totalElements!!;
        //this.pageConfig.itemsPerPage = resp.page?.size!!;
        this.listPartners=resp.content||[];
       
        this.isAddPartner =false;
        this.isUpdatePartner =false;
        console.log(this.pageConfig);
      },
      error:(err)=>{
        this.session.handleError(err);
      }
      
    });
  }
  addPartner(){
    this.isAddPartner =true;
    this.isUpdatePartner =false;
    console.log(this.isAddPartner);
    console.log(this.isUpdatePartner);
  }
  
    setPartnerDetails(partner:PartnerDto){
      
      this.partnerService.getPartnerDetails(
        partner.id!!
      ).subscribe({
        next:(resp)=>{
          this.isUpdatePartner =true;
          this.isAddPartner = false;
          this.updatePartnerForm.controls['partnerId'].setValue(partner.id);
          this.updatePartnerForm.controls['parentId'].setValue(partner.parent?.id);
          this.updatePartnerForm.controls['partnerName'].setValue(resp.name);
          this.updatePartnerForm.controls['partnerAddress'].setValue(partner.address);
          this.updatePartnerForm.controls['partnerEmail'].setValue(partner.email);
          this.updatePartnerForm.controls['partnerMcc'].setValue(partner.mcc);
          this.updatePartnerForm.controls['partnerPhone'].setValue(resp.phone);
          this.updatePartnerForm.controls['partnerCountry'].setValue(resp.country?.isoCode2);
          this.updatePartnerForm.controls['partnerCurrency'].setValue(resp.currency?.code);
          this.updatePartnerForm.controls['partnerType'].setValue(resp.type);
        },
        error:(err)=>{

        }
      });
      
    }
    onUpdatePartner():void{
      if(this.updatePartnerForm.valid){
  
        let formVal =this.updatePartnerForm.value;
        
        let pCountry:Country={
          isoCode2: formVal.partnerCountry
        };
        let pCurrency:Currency ={
          code: formVal.partnerCurrency
        };
        
        let partnerDto:PartnerDto ={
          id:formVal.partnerId,
          name: formVal.partnerName,
          phone: formVal.partnerPhone,
          email: formVal.partnerEmail,
          type: formVal.partnerType,
          address: formVal.partnerAddress,
          parent: {id: formVal.parentId} as PartnerDto,
          country:pCountry,
          currency:pCurrency,
          mcc: formVal.partnerMcc,
         };
        this.partnerService.editPartner1(
        partnerDto
        ).subscribe({
          next:()=>{
            
            this.updatePartnerForm.reset();
            this.isUpdatePartner=false;
            
             const modAdd = new bootstrap.Modal('#modAddPartner',{});
             modAdd.show();
  
          },
          error:(err)=> {
             this.session.handleError(err);
          },
        });
  
      }else {
        console.log(this.addPartnerForm.errors);
      }
    }
    displayPartnerDetails(partner:PartnerDto){
      this.partnerService.getPartnerDetails(
        partner.id!!
      ).subscribe({
        next:(resp)=>{
        this.currentPartner = resp; 
        const modAdd = new bootstrap.Modal('#detailsPartner',{});
             modAdd.show();
        }
      });
    }
 
}
